<template>
  <TileChartCard @update:size="setOptimalChartSize">
    <template #element-content>
      <transition name="el-fade-in-linear">
        <section
          v-loading="isLoading"
          class="activity-tile-box"
        >
          <apexchart
            ref="activityReportLineChart"
            :height="chartHeight"
            :width="chartWidth"
            :options="barChartOptions"
            :series="barChartSeries"
          />
        </section>
      </transition>
    </template>
  </TileChartCard>
</template>

<script lang="ts">
import Component, { mixins } from 'vue-class-component'
import TileChartCard from '../../components/UI/TileChartCard.vue'
import {
  PackageItemsShippedStatisticsQuery,
  PackagesShippedStatisticsQuery
} from '@/types/graphql'
import { DataChartMixin } from '@/components/Activity/mixins/DataChartMixin'

// ⁡⁢⁣⁣⁡⁢⁣⁣⓿ ⁡⁢⁣⁣𝗧𝘆𝗽𝗲𝘀⁡

@Component({
  components: {
    TileChartCard
  }
})
export default class ActivityTile extends mixins(DataChartMixin) {
  protected packagesStatisticsQuery = PackagesShippedStatisticsQuery;

  protected packagesQueryName = 'packagesShippedStatistics';

  protected packageItemsStatisticsQuery = PackageItemsShippedStatisticsQuery;

  protected packageItemsQueryName = 'packageItemsShippedStatistics';

  private chartHeight = 0;

  protected setOptimalChartSize(val: any) {
    this.chartWidth = Math.round(val.elementWidth)
    this.chartHeight = Math.round(val.elementHeight)
  }
}
</script>

.<style lang="scss">
.activity-tile-box {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  .apexcharts-legend-text {
    .legend-space {
      margin-right: 12px;
    }
  }
}
</style>
